var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOvalBaselineLock24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#87CEFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5H18V11C18 10.2044 17.6839 9.44129 17.1213 8.87868C16.5587 8.31607 15.7956 8 15 8C14.2044 8 13.4413 8.31607 12.8787 8.87868C12.3161 9.44129 12 10.2044 12 11V12.5H10C9.73478 12.5 9.48043 12.6054 9.29289 12.7929C9.10536 12.9804 9 13.2348 9 13.5V20.5C9 20.7652 9.10536 21.0196 9.29289 21.2071C9.48043 21.3946 9.73478 21.5 10 21.5H20C20.2652 21.5 20.5196 21.3946 20.7071 21.2071C20.8946 21.0196 21 20.7652 21 20.5V13.5C21 13.2348 20.8946 12.9804 20.7071 12.7929C20.5196 12.6054 20.2652 12.5 20 12.5ZM15.5 17.4144V19C15.5 19.1326 15.4473 19.2598 15.3536 19.3536C15.2598 19.4473 15.1326 19.5 15 19.5C14.8674 19.5 14.7402 19.4473 14.6464 19.3536C14.5527 19.2598 14.5 19.1326 14.5 19V17.4144C14.1664 17.2964 13.8852 17.0643 13.7062 16.7591C13.5271 16.4539 13.4618 16.0953 13.5216 15.7465C13.5814 15.3978 13.7626 15.0814 14.0332 14.8533C14.3037 14.6253 14.6462 14.5002 15 14.5002C15.3538 14.5002 15.6963 14.6253 15.9668 14.8533C16.2374 15.0814 16.4186 15.3978 16.4784 15.7465C16.5382 16.0953 16.4729 16.4539 16.2938 16.7591C16.1148 17.0643 15.8336 17.2964 15.5 17.4144ZM17 12.5H13V11C13 10.4696 13.2107 9.96086 13.5858 9.58579C13.9609 9.21071 14.4696 9 15 9C15.5304 9 16.0391 9.21071 16.4142 9.58579C16.7893 9.96086 17 10.4696 17 11V12.5Z",
    fill: "#0033AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOvalBaselineLock24Px);
export default __webpack_public_path__ + "static/media/ic_oval-baseline-lock-24px.895af5938782799a70b6d360d684e9da.svg";
export { ForwardRef as ReactComponent };